import { UserDto } from "../services/bbo-client.service";

export class User {
	/** List of users main purview names (ABMs). */
	purviewNames: string[];
	/**
	 * Users full ASBNET name.
	 * @example 'Koch Josef EXTERN'
	 */
	fullName: string;
	/**
	 * Users login name.
	 * @example 'ext_KochJo'
	 */
	loginName: string;
	/**
	 * The date when the users token expires.
	 */
	token: string;

	constructor(res: UserDto) {
		this.purviewNames = (res.abms as string).split("|").filter((abm) => abm);
		this.fullName = res.fullName as string;
		this.loginName = res.loginName as string;
		this.token = res.accessToken as string;
	}
}
